import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        paper: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(1),
            gap: theme.spacing(2)
        },
        customStrategyViewContainer: {
            width: '100%'
        },
        header: {
            display: 'flex',
            flex: 1
        },
        strategiesContainer: {
            width: '100%',
            flex: 1,
            overflowY: 'auto',
            minHeight: 0
        },
        strategyGroupContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing(1),
            alignItems: 'start'
        },
        strategyGroup: {
            flex: 1,
            display: 'flex',
            minWidth: 0,
            gap: theme.spacing(1)
        },
        strategyTile: {
            position: 'relative',
            width: '100%',
            // borderWidth: 1,
            display: 'flex',
            padding: theme.spacing(2),
            cursor: 'pointer',
            flexDirection: 'row',
            gap: theme.spacing(2),
            '&:hover .MuiIconButton-root': {
                visibility: 'visible'
            }
        },
        strategyTileLoading: {
            cursor: 'not-allowed'
        },
        strategyIcon: {
            width: 30,
            height: 30
        },
        strategyDetails: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'start',
            flex: 1,
            gap: theme.spacing(1),
            minWidth: 0
        },
        strategyLabel: {
            lineHeight: 1.5,
            whiteSpace: 'normal',
            width: '100%',
            maxWidth: '100%'
        },
        strategyDescription: {
            lineHeight: 1.5,
            whiteSpace: 'normal',
            width: '100%',
            maxWidth: '100%'
        },
        predefinedStrategiesContainer: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            width: '100%',
            minHeight: 0
        }
    }
})
